module.exports = __webpack_public_path__ + "static/media/item_stored.26d98958.png";